<template>
  <div class="survey-view">
    <transition name="fade">
      <action-dispatcher action="user/getSurvey">
        <component
          v-if="$user.user"
          :is="stepComponent[step]"
          @advance="advance"
        />
      </action-dispatcher>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SurveyEnd from "../components/survey/SurveyEnd.vue";
import SurveyQuestions from "../components/survey/SurveyQuestions.vue";
import SurveyStart from "../components/survey/SurveyStart.vue";
export default {
  data() {
    return {
      step: 1,
      stepComponent: {
        1: SurveyStart,
        2: SurveyQuestions,
        3: SurveyEnd
      }
    };
  },
  computed: {
    ...mapState("user", ["survey"])
  },
  methods: {
    advance() {
      if (this.step === 3) return this.$router.push({ name: "home" });
      this.step++;
    }
  }
};
</script>

<style lang="scss" scoped>
.survey-view {
  min-height: 100vh;
  background: #fafbfc;
  .fade-enter-active {
    transition-duration: 2s;
  }
}
::v-deep {
  .survey-start,
  .survey-end {
    h1 {
      font-size: 56px;
      line-height: normal;
      letter-spacing: 0.084px;
    }
    h2 {
      font-size: 41px;
      line-height: normal;
      letter-spacing: 0.062px;
    }
    p {
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0.036px;
    }
    @media screen and (max-width: 991px) {
      h1 {
        text-align: center;
        font-size: 36px;
        line-height: 48px; /* 133.333% */
        letter-spacing: 0.09px;
      }
      h2 {
        text-align: center;
        font-size: 24px;
        line-height: 32px; /* 133.333% */
      }
      p {
        text-align: center;
        font-size: 16px;
        line-height: 32px; /* 200% */
        letter-spacing: 0.08px;
      }
    }

    display: flex;
    flex-direction: column;
    .content {
      display: flex;
      flex-direction: column;
      padding: 24px 16px 0;
    }
    img {
      width: 100%;
    }
    .cta-button {
      bottom: 20px;
      position: fixed;
      width: calc(100% - 32px);
    }
    @media screen and (min-width: 992px) {
      flex-direction: row;
      .content {
        padding: 40px;
        min-height: 100vh;
        justify-content: center;
      }
      img {
        width: auto;
        height: 100vh;
        object-fit: cover;
      }
    }
  }
}
</style>
